// extracted by mini-css-extract-plugin
export default {"container":"generate_container__Fzuvz","methods":"generate_methods__VidjS","title":"generate_title__KDmfs","definition":"generate_definition__+TjTp","image":"generate_image__7uCtz"};